import { NodeModel } from "../_model/NodeModel";
import { DecorationCornMill } from "./decorationCornMill";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class CornMill extends NodeModel {
  constructor() {
    super("CornMill");

    this.type = new Types().CornMill;
    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 100;
    this.width = 180;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/moinho_milho.png");
    this.data = [new Properties({ ...this })];

    this.decorate = async function(callback) {
      this.decorator = new DecorationCornMill();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new CornMill();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible
      cloned.decorator = null;
      cloned.data = this.data.map((d) => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }
      this.expressionVisible = node.expressionVisible;
    };
  }
}

export { CornMill };
